"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const toolkit_1 = require("@reduxjs/toolkit");
const app_types_1 = require("pages/app.types");
const contractor_types_1 = require("./contractor.types");
const initialState = {
    isLoading: true,
    isError: false,
    isSuccess: false,
    errorCode: 0,
    errorMessage: '',
    dataGrid: [],
    dataEnum: [],
    mutationMode: false,
    dataItem: {
        id: '0',
        contractor_code: '',
        contractor_name: '',
        contractor_type: '',
        coal_hauling: false,
        coal_mining: false,
        is_active: {
            value: true,
            status: 'Active'
        },
        modified_by: '',
        modified_date: new Date(),
        created_by: '',
        created_date: new Date(),
        generated_filename: '',
        url: ''
    },
    dataStates: {
        filterable: true,
        sortable: true,
        reorderable: false,
        scrollable: 'scrollable',
        skip: 0,
        take: 10,
        total: 0,
        sort: [{ field: 'modified_date', dir: 'desc' }]
    }
};
const contractorReducer = (0, toolkit_1.createReducer)(initialState, {
    [app_types_1.appTypes.RESET_LOADING]: () => {
        return Object.assign({}, initialState);
    },
    [contractor_types_1.contractorTypes.SET_DATA_GRID]: (state, action) => {
        const { dataGrid, count } = action.payload;
        return Object.assign(Object.assign({}, state), { dataGrid, isLoading: false, dataStates: Object.assign(Object.assign({}, state.dataStates), { total: count }) });
    },
    [contractor_types_1.contractorTypes.ON_PAGE_CHANGE]: (state, action) => {
        const { dataGrid, dataStates } = action.payload;
        return Object.assign(Object.assign({}, state), { dataGrid,
            dataStates, isLoading: false });
    },
    [contractor_types_1.contractorTypes.ON_MUTATION_CLICK]: (state, action) => {
        const { dataItem, mutationMode, isSuccess } = action.payload;
        return Object.assign(Object.assign({}, state), { dataItem: dataItem ? dataItem : initialState.dataItem, mutationMode: mutationMode, isSuccess: isSuccess ? isSuccess : initialState.isSuccess });
    },
    [contractor_types_1.contractorTypes.ON_SAVE_DATAITEM]: (state, action) => {
        const { dataItem, isSuccess } = action.payload;
        return Object.assign(Object.assign({}, state), { isSuccess, mutationMode: false, dataItem: initialState.dataItem, dataGrid: state.dataGrid.map(item => {
                if (item.id === dataItem.id)
                    return dataItem;
                return item;
            }) });
    },
    [contractor_types_1.contractorTypes.ON_DELETE_DATAITEM]: (state, action) => {
        const { dataItem, isSuccess } = action.payload;
        return Object.assign(Object.assign({}, state), { isSuccess, mutationMode: false, dataItem: initialState.dataItem, dataGrid: state.dataGrid.filter(item => item.id !== (dataItem === null || dataItem === void 0 ? void 0 : dataItem.id)) });
    },
    // [contractorTypes.SET_DATA_ENUM]:(state, action:PayloadAction<Required<IContractorTypes.IEnumItem[]>>) => {
    //   const contractor_data:IContractorTypes.IEnumItem =
    //   action.payload.find(item => item.value === state.dataItem.contractor_type) ||
    //   {
    //     id:'',
    //     type:'',
    //     value:'',
    //     is_active:false,
    //     created_by: '',
    //     created_date:new Date(),
    //     modified_by:'',
    //     modified_date:new Date()
    //   }
    //   return {
    //     ...state,
    //     dataEnum: action.payload,
    //     dataItem: {
    //       ...state.dataItem,
    //       contractor_data,
    //       contractor_type: contractor_data.id
    //     }
    //   }
    // },
    [contractor_types_1.contractorTypes.ON_FILTER_CHANGE]: (state, action) => {
        return Object.assign(Object.assign({}, state), { isLoading: true, dataStates: Object.assign(Object.assign({}, state.dataStates), { filter: action.payload, skip: initialState.dataStates.skip }) });
    },
    [contractor_types_1.contractorTypes.ON_SORT_CHANGE]: (state, action) => {
        return Object.assign(Object.assign({}, state), { isLoading: true, dataStates: Object.assign(Object.assign({}, state.dataStates), { sort: action.payload }) });
    },
    [contractor_types_1.contractorTypes.SET_ERROR]: (state, action) => {
        const { isError, errorCode, errorMessage } = action.payload;
        return Object.assign(Object.assign({}, state), { isError, errorCode, errorMessage, isLoading: false });
    },
    [contractor_types_1.contractorTypes.SET_LOADING]: (state, action) => {
        return Object.assign(Object.assign({}, state), { isLoading: action.payload });
    }
});
exports.default = contractorReducer;
